import { track } from '../utils';

export function manualAddSearchManufacturer(
  Studio: string,
  search: string,
  results: boolean,
) {
  track('Manual Add Search Manufacturer', {
    Studio,
    'Search Criteria': search,
    'Results found': results,
  });
}

export function manualAddSelectManufacturer(
  Studio: string,
  manufacturerId: string,
  manufacturerName: string,
) {
  track('Manual Add Select Manufacturer', {
    Studio,
    'Manufacturer Name': manufacturerName,
    'Manufacturer ID': manufacturerId,
  });
}

export function manualAddSearchProduct(
  Studio: string,
  search: string,
  results: boolean,
) {
  track('Manual Add Search Product', {
    Studio,
    'Search Criteria': search,
    'Results found': results,
  });
}

export function manualAddSelectProduct(
  Studio: string,
  productId: string,
  productName: string,
) {
  track('Manual Add Select Product', {
    Studio,
    'Product Name': productName,
    'Product ID': productId,
  });
}

export function manualAddProductDetails(Studio: string, productId: string) {
  track('Manual Add Product Details', {
    Studio,
    'Product ID': productId,
  });
}

export function manualAddSkipProduct(Studio: string, search: string) {
  track('Manual Add Skip Product', {
    Studio,
    'Search Criteria': search,
  });
}

export function manualAddConfirm(Studio: string, amount: number) {
  track('Manual Add Confirm', {
    Studio,
    '# of Assets': amount,
  });
}

export function manualAddAdded(Studio: string, onboardNow: boolean) {
  track('Manual Add Added', {
    Studio,
    'Next Action': onboardNow ? 'Onboard Now' : 'Dismiss Onboard',
  });
}
